import './inputs.css'
export function Input(props) {
    
    return (
        <div style={props.style} className="input-component">
            <div>
                <img style={props.icon ? { display: 'flex' } : { display: 'none' }} src={props.icon} alt='icon to input' />
                <h3 style={props.title ? { fontSize: props.titleSize, display: "flex" } : { display: 'none' }} className="montserrat">{props.title}</h3>
                <h5 className='w600' style={props.notShowRequired ? { display: 'none' } : props.required ? { display: "flex" } : { display: 'none' }}>*</h5>
            </div>
            {
                props.tag ?
                    props.tag === 'select' ?
                        <props.tag value={props.value} disabled={props.disabled} onChange={props.onChange} name={props.name} required={props.required} style={props.props}>
                                {props.children}
                        </props.tag>
                        :
                        <props.tag onChange={props.onChange} name={props.name} placeholder={props.placeholder} required={props.required} style={props.props} type={props.type} />
                    :
                    props.type === 'radio' || props.type === 'checkbox' ?
                        <div style={{ display: 'flex' }}>
                            <input value={props.value} disabled={props.disabled} id='input' name={props.name} onChange={props.onChange} placeholder={props.placeholder} required={props.required} style={props.props} checked={props.checked} type={props.type} />
                            <label style={{ ...props.widthLabel, fontSize: props.labelSize }} for='input'>{props.label}</label>
                        </div>
                        :
                        <input value={props.value} disabled={props.disabled} max={props.max} name={props.name} onChange={props.onChange} placeholder={props.placeholder} required={props.required} style={props.props} type={props.type} />
            }
            <h4 style={props.example ? { display: 'flex' } : { display: 'none' }} className="montserrat">{props.example}</h4>
        </div>
    )
}